export type Question =
  { id: number
  , title: string
  , fullQuestion: string
  , answer: string
  , slug: string
  , numViews: number
  , attributeAnswerToAdvisor: boolean
  , timestamp: string
  }

export function timestampDescription(question: Question) {
  return new Date(question.timestamp).toLocaleDateString('en-US',{
    day: '2-digit',
    month: 'long',
    year: 'numeric',
    hour: 'numeric',
    minute: '2-digit'
  })
}
